import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))

/** Today's calendar date in UTC as YYYY-MM-DD (effective-date semantics). */
export const todayISO = (now: Date = new Date()): string =>
  now.toISOString().slice(0, 10)

